import React from 'react';

const CheckInButton = ({checkIn, label}) => {
    return (
      <button className="dropdown-item" id="map-check-in-button" onClick={checkIn}>
        {label}
      </button>
    );
};
  

export default CheckInButton ;